import { useTranslation } from 'react-i18next'

import { LANGUAGES } from '../../constants/languages'
import type { Language } from '../../types/common'
import classNames from '../../utils/classNames'

const LanguageSelector = () => {
  const { i18n } = useTranslation()
  const { language, changeLanguage } = i18n

  const setLanguage = async (newLanguage: Language) => {
    await changeLanguage(newLanguage)
    document.documentElement.setAttribute('lang', newLanguage)
    window.location.reload()
  }

  return (
    <div className="flx-ctr gap-10 pt-[25px]">
      {LANGUAGES.map(lang => (
        <button
          key={lang.key}
          onClick={() => setLanguage(lang.key)}
          className={classNames(
            'transition-all duration-[0.2s] ease-[ease-in-out] text-[15px] flex items-center',
            language === lang.key
              ? 'text-[#df0033]'
              : 'text-[#888] dark:text-white',
          )}>
          <img className="w-[17px] mr-2 -mt-px" src={lang.image} />
          {lang.name}
        </button>
      ))}
    </div>
  )
}

export default LanguageSelector
